// extracted by mini-css-extract-plugin
export var avatarContainer = "_ax-0";
export var avatarTypingWave = "_ax-i";
export var gray = "_ax-f";
export var green = "_ax-c";
export var icon = "_ax-9";
export var image = "_ax-1";
export var lg = "_ax-6";
export var md = "_ax-5";
export var presenceDot = "_ax-b";
export var red = "_ax-d";
export var sm = "_ax-4";
export var status = "_ax-a";
export var typingDot = "_ax-h";
export var typingPill = "_ax-g";
export var xl = "_ax-7";
export var xs = "_ax-3";
export var xxl = "_ax-8";
export var xxs = "_ax-2";
export var yellow = "_ax-e";